import { render, staticRenderFns } from "./IndustryTypeManagement.vue?vue&type=template&id=3281abf8&scoped=true"
import script from "./IndustryTypeManagement.vue?vue&type=script&lang=js"
export * from "./IndustryTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./IndustryTypeManagement.vue?vue&type=style&index=0&id=3281abf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3281abf8",
  null
  
)

export default component.exports